import { NAMESPACE } from './constants';

export const SHOW_LOADER = `${NAMESPACE}/SHOW_LOADER`;
export const ATTACH_FILE = `${NAMESPACE}/ATTACH_FILE`;
export const EXCEED_FILE_SIZE = `${NAMESPACE}/EXCEED_FILE_SIZE`;
export const SELECT_FILE = `${NAMESPACE}/SELECT_FILE`;
export const NO_FILES_AVAILABLE = `${NAMESPACE}/NO_FILES_AVAILABLE`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const SELECT_RIGHT_PANEL_TAB = `${NAMESPACE}/SELECT_RIGHT_PANEL_TAB`;
export const SELECT_LEFT_PANEL_TAB = `${NAMESPACE}/SELECT_LEFT_PANEL_TAB`;
